import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-room-type-list',
	templateUrl: './room-type-list.component.html',
	styleUrls: ['./room-type-list.component.css'],
})
export class RoomTypeListComponent extends ListComponent {
	protected apiUrl = 'product/room/type';
	protected apiType = 'bag';
	codebook;
	title: string;
	tableRows = [
		{ id: 'name', name: 'Nazwa' },
		{ id: 'code', name: 'Kod' },
		{ id: 'kind', name: 'Rodzaj' },
	];

	filters = {
		limit: 9999,
	};

	protected loadBefore(): void {
		this.bag.get('/codebook/2/', (result, error) => {
			this.codebook = result;

			this.title = `Słowniki -> ${this.codebook.name}`;
			this.loadData();
		});
	}
	protected convertData(data: any) {
		data.results.map((element) => {
			if (element.kind === 'A') {
				element.kind = 'Apartament';
			} else if (element.kind === 'S') {
				element.kind = 'Studio';
			} else if (element.kind === 'R') {
				element.kind = 'Pokój';
			}
		});

		return data.results;
	}
}
